import React, { Component, useMemo, useState } from 'react';

import CreatableSelect from 'react-select/creatable';
import { ActionMeta, components, OnChangeValue } from 'react-select';
import DropdownIcon from "../../assets/images/faq/btn/down_arrow.svg";
import ClearIcon from "../../assets/images/del/delete.svg";

const CustomSelect = ({options, onChange, value, name, placeholder}) => {

  const getValue = () => {
    if (options.length > 0) {
      const result = options.find(option => option.value === value);
      return result;
    } else {
      return "";
    }
  };

     

  const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator style={{padding: "0 !important"}} {...props}>
          <img style={{marginLeft: "0.5rem", width: "3rem"}} src={DropdownIcon} />
        
      </components.DropdownIndicator>
    );
  };

  const ClearIndicator = props => {
    return (
      <components.ClearIndicator {...props}>
        <img style={{width: "3.5rem"}} src={ClearIcon} />
      </components.ClearIndicator>
    );
  };

  const customStyles = () => ({
    menu: (provided, state) => ({
      ...provided,
      border: "1px solid #e2e2e2",
      marginTop: "-0.2rem",
      background: "#fff",
      position: "absolute",
      zIndex: 2,
      borderRadius: "0 0 3rem 3rem",
      overflow: "hidden"
    }),

    control: (provided, state) => ({
      ...provided,
      background: "#13320C",
      padding: "1.5rem 0.5rem 1.5rem 4rem",
      borderRadius: state.menuIsOpen ? "3rem 3rem 0 0" : "4rem",
      fontFamily: "Jost",
      fontSize: "1.8rem",
      fontWeight: "600",
      border: 0,
      boxShadow: 0,
      color: "white"
    }),

    placeholder: (provided, state) => ({
      ...provided,
      color: "grey",
      fontFamily: "Jost",
      fontSize: "1.8rem",
      textTransform: "UpperCase",
      overflow: "hidden"
    }),

    option: (provided, state) => ({
      ...provided,
      color:  "black",
      padding: "1.3rem 1.9rem 1.2rem",
      fontSize: "16px",
      fontWeight: "500",
      borderBottom: "1px solid #ccc"
    }),

    singleValue: (provided, state) => ({
      ...provided,
      color: "white",
    }),

    input: (provided, state) => ({
      ...provided,
      color: "white",
    }),

    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: "0 0.5rem",
    }),

  });

    return (
      <CreatableSelect
        isClearable={false}
        onChange={onChange}
        name={name}
        components = {{ DropdownIndicator }}
        value={getValue()}
        options={options}
        styles={customStyles()}
        placeholder={placeholder}
        isSearchable={false}
      />
    );
}

export default CustomSelect;
